import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import routes from 'constants/routes';
import asyncComponent from './asyncComponent';
import getPageContainer from './getPageContainer';

const NotFoundPage = asyncComponent(() => import('containers/NotFoundPage'));
const Routes = () => {
  return (
    <Switch>
      {Object.values(routes).map(route => (
        <Route
          exact
          path={route.pathname}
          key={route.pageTitle}
          component={getPageContainer(route.component)}
        />
      ))}
      {/* 404 */}
      <Route exact path={routes.notFound.pathname} component={NotFoundPage} />
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default withRouter(Routes);
